export default __webpack_public_path__ + "static/media/BG-DarkBlue-0000.ff83f750.png";